module.exports = __webpack_public_path__ + "static/media/z2_4.f67ed9aa.png";